import * as Sentry from "@sentry/react";
import { useEditorState } from "@/store/editorState";

export const sentryRegisterStateBreadcrumb = (editorState: typeof useEditorState) => {
  Sentry.addEventProcessor((event) => {
    // event.type is undefined for errors; skip transactions/replays/sessions
    if (event.type !== undefined) return event;
    if (!editorState) return event;

    const state = editorState.getState();
    const stateJson = state.toJson();

    // 1. Add tags directly to the event payload
    event.tags = {
      ...event.tags,
      stembox_branch: state.project?.stembox_branch,
      project: state.project?.project_id,
      project_type: state.project?.project_type,
      user_name: state.sessionUser?.username,
      user_id: state.sessionUser?.id,
    };

    const stateData = JSON.parse(stateJson);
    const keys = Object.keys(stateData);
    const mid = Math.ceil(keys.length / 2);

    const firstHalf: Record<string, unknown> = {};
    const secondHalf: Record<string, unknown> = {};

    const excludeKeys = ["verifyResponse", "ridersUser", "layout", "achievements", "yamData", "configJson"];
    keys.forEach((key, i) => {
      if (excludeKeys.includes(key)) return;
      if (i < mid) {
        firstHalf[key] = stateData[key];
      } else {
        secondHalf[key] = stateData[key];
      }
    });

    const now = Date.now() / 1000;

    const breadcrumb1: Sentry.Breadcrumb = {
      category: "editorState",
      message: "Editor state at error time (1/2)",
      level: "info",
      timestamp: now,
      data: firstHalf,
    };

    const breadcrumb2: Sentry.Breadcrumb = {
      category: "editorState",
      message: "Editor state at error time (2/2)",
      level: "info",
      timestamp: now,
      data: secondHalf,
    };

    event.breadcrumbs = [...(event.breadcrumbs ?? []), breadcrumb1, breadcrumb2];

    if (!event.level) {
      event.level = "fatal";
    }

    return event;
  });
}